import { Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { StepDefinition } from '../dynamic';
import { FieldType, FormlyFieldConfig } from '@ngx-formly/core';
import { ContextService, ServerServiceConfig } from '../../context.service';
import { FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';

@Component({
  selector: 'mutara-radio-controller',
  template: `<div class='sticky'><ng-container #fieldComponent></ng-container></div>`,
  standalone: false
})
export class RadioControllerComponent extends FieldType implements OnInit, OnDestroy {
  appDefinition: ServerServiceConfig | undefined;
  loaded: boolean = false;
  subscriptions: Subscription[] = [];
  
  constructor(private context: ContextService, public host: ElementRef) {
    super();
  }

  get localModel(): StepDefinition[] {
    return this.props.dataModel;
  }

  get parentGroup(): FormlyFieldConfig {
    return this.props.parentGroup;
  }

  get debug() : boolean {
    return this.props?.capForm?.debug;
  }
  /** 
   * Initialize the wrapper
   */
  ngOnInit(): void {
    // console.log('It begins %O', this.field.formControl);
    this.props.fieldsToWatch = {};

    // Look for fields that meet the radio button criteria
    let children = [...(<any>this.parentGroup).fieldGroup], currentField;
    while (!!(currentField = children.shift())) {
      switch (currentField.type) {
        case 'formly-group':
          children = children.concat([...currentField.fieldGroup].filter(fld => fld.key != this.key));
          continue;
      }
    }
    this.context.subscribeTo("applicationInfo", (app : ServerServiceConfig) => this.appDefinition = app );
    this.context.subscribeTo("readyToReceive", (isReady : boolean) => {
      if (isReady && !this.loaded) {
        let localData : any = this.field.props?.getValue();
        // console.log('Started With %O->%O', this.key, localData);
        this.setupRadioSiblings(localData);
        this.loaded = true;
      }
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach( sub => sub.unsubscribe() );
    this.subscriptions = [];
  }
  /**
   * After the first validity check, add the mappings for each field in the group
   */
  setupRadioSiblings(startingValue : any ) {
    for (let key in this.props.fieldsToWatch) {
      let fieldConfig = this.props.fieldsToWatch[key];
      fieldConfig.props.sortableOptions.selectedValue = startingValue;

      (<FormControl>fieldConfig.formControl)?.valueChanges.subscribe(
        {
          next: (newValue) => {
            if ( this.debug ) { console.log( 'VC %O RadioSiblings %O', this.key, newValue ); }
            if (newValue != null) {
              for (let sibKey in this.props.fieldsToWatch) {
                let sibling = this.props.fieldsToWatch[sibKey];
                if (sibKey != key) {
                  sibling.props.setValue(null);
                }
              };
              this.field.props?.setValue(newValue);
            }
          }
        });
    };

    this.field.formControl?.setValue(startingValue);
    this.field.formControl?.updateValueAndValidity();

//    this.props.capForm.cdr.markForCheck();
  }
}
